import type { Column } from '../pdf-preview-v2/types';

/** Default colors applied by BE if not provided in the settings */
export const DEFAULT_COLORS = {
  colorText: '#1d1d1b',
  colorTextAlt: '#ffffff',
  colorTheme: '#1d1d1b',
} as const;

export enum PLACEHOLDERS {
  ALL = 'ALL',

  // HEADER
  DocumentNumber = 'DocumentNumber',
  DocumentNumberValue = 'DocumentNumberValue',
  ClientDetails = 'ClientDetails',
  ClientDetailsValue = 'ClientDetailsValue',
  DocumentDetails = 'DocumentDetails',
  DocumentDetailsValue = 'DocumentDetailsValue',

  // ADDRESSES
  MerchantName = 'MerchantName',
  MerchantAddress = 'MerchantAddress',
  ClientName = 'ClientName',
  ClientAddress = 'ClientAddress',

  // MAIN
  HeaderNotes = 'HeaderNotes',
  Items = 'Items',
  FooterNotes = 'FooterNotes',

  // CONDITIONS
  Conditions = 'Conditions',
  TermsAndConditions = 'TermsAndConditions',

  // FOOTER
  Footer = 'Footer',
  FooterPaymentDetails = 'FooterPaymentDetails',
}

export const CURRENCIES = {
  DEFAULT: 'EUR',
} as const;

export const STATUS = {
  DRAFT: 'draft',
} as const;

export const ORIGIN = {
  MODAL: 'invoice-modal',
  FORM: 'invoice-form',
  SETTINGS: 'settings-form',
} as const;

export const SELF_BILLING_DOCUMENT_TYPE = {
  TD17: 'TD17',
  TD18: 'TD18',
  TD19: 'TD19',
};

export const DEFAULT_COLUMNS: Column[] = [
  { id: 'description' },
  { id: 'quantity' },
  { id: 'unit_price' },
  { id: 'vat_rate' },
  { id: 'subtotal' },
];

export const DEFAULT_PARTIAL_INVOICE_COLUMNS: Column[] = [
  { id: 'description' },
  { id: 'quantity' },
  { id: 'unit_price' },
  { id: 'progress' },
  { id: 'cumulative_progress' },
  { id: 'vat_rate' },
  { id: 'subtotal' },
];
